import { status } from '../../helpers'

const getBillingStoreDefaultState = () => {
  return {
    paymentMethods: [],
    loadPaymentMethods: status.INITIALIZED,
    submittingPaymentMethod: false,
    newInvoiceMethod: {
      firstName: '',
      lastName: '',
      accountEmail: '',
      accountPhone: ''
    },
    loadInvoices: status.INITIALIZED,
    invoices: [],
    plans: [],
    selectedPlanIfNoPaymentsCreated: null,
    loadPlans: status.INITIALIZED,
    loadingSubscription: status.INITIALIZED,
    currentSubscription: {},
    updatingCurrentSubscription: false,
    loadSubscriptionAlerts: status.INITIALIZED,
    subscriptionAlerts: [],
    paymentMethodCount: 0,
    invoiceCount: 0
  }
}

export default getBillingStoreDefaultState
